import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Paragraph } from '@vwfs-bronson/bronson-react';

interface Props {
  visible: boolean;
  onCancel: any;
  onConfirm: any;
}

export const NewCopiedQuoteModal: FunctionComponent<Props> = (props) => {
  const { t } = useTranslation();
  const { visible, onCancel, onConfirm } = props;

  return (
    <Modal
      id="newCopiedQuoteModal"
      title=""
      hideTitle
      buttonConfirmText={t('step1:configVehicle:newCopiedQuoteModal:continueButton')}
      buttonCancelText={t('step1:configVehicle:newCopiedQuoteModal:backButton')}
      shown={visible}
      onClose={() => onCancel()}
      onCancel={() => {
        onCancel();
      }}
      onConfirm={() => {
        onConfirm();
      }}
      asPortal
    >
      <Paragraph>{t('step1:configVehicle:newCopiedQuoteModal:text')}</Paragraph>
    </Modal>
  );
};
